{
  "version": 1,
  "asset_id": "d06ec64e-8e67-4181-898c-7c92f61cd24d",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/d06ec64e-8e67-4181-898c-7c92f61cd24d/avcilar-hizli-elektrikci-7-24-dukkan-3.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/d06ec64e-8e67-4181-898c-7c92f61cd24d/avcilar-hizli-elektrikci-7-24-dukkan-3.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-3.jpg",
  "size": 513757,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:34Z"
}
